module.exports = __webpack_public_path__ + "img/xxnl-product4.38aec536.png";